import type { LineItemScan as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as ScanUser from './ScanUser';

/**
 * One scan event on a ticket. A ticket can be scanned more than once, which is why the order detail
 * reads this list rather than a single `checkedInBy` field.
 */
export type LineItemScan = {
  scannedAt: string;
  scannedBy?: ScanUser.ScanUser;
};

export const fromGql = (item: GQLItem): LineItemScan => ({
  ...take<LineItemScan>(item, 'scannedAt'),
  scannedBy: item.scannedBy ? ScanUser.fromGql(item.scannedBy) : undefined,
});
